import { Editor } from 'slate'

export function isMarkActive (editor, format) {
  let marks = null

  try {
    marks = Editor.marks(editor)
  } catch (err) {
    // Do nothing
  }

  return marks
    ? marks[format] === true
    : false
}
